import React from 'react';

import { ConnectComponentsProvider, ConnectPayments } from '@stripe/react-connect-js';

import { WorkspaceLayout } from '../../../shared/components/Layout';
import { useStripeConnect } from '../../../shared/hooks';

import styles from '../../../shared/styles/_layout.module.scss';

const Dashboard = () => {
  const { stripeConnectInstance } = useStripeConnect();

  return (
    <WorkspaceLayout>
      <h1 className={styles.dashboard__title}>Payments</h1>

      {stripeConnectInstance && (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectPayments />
        </ConnectComponentsProvider>
      )}
    </WorkspaceLayout>
  );
};

export default Dashboard;
